import { render, staticRenderFns } from "./layoutEditor.vue?vue&type=template&id=0b00b430&"
import script from "./layoutEditor.vue?vue&type=script&lang=ts&"
export * from "./layoutEditor.vue?vue&type=script&lang=ts&"
import style0 from "./layoutEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports